import React from 'react';
import styled from '@emotion/styled';
import { TextField } from '../../../../../components/TextField';
import { PlanoCard } from '../plano-list/plano-card';


export const ConfirmDados = ({ dadosCadastrais , whitelabel}) => {


  const campos = [
    {
      label: 'Nome',
      key: 'nome',
    },
    {
      label: 'CPF',
      key: 'cpf',
      mask: 'cpf',
    },
    {
      label: 'Telefone',
      key: 'telefone',
      mask: 'phone',
    },
    {
      label: 'Email',
      key: 'email',
    },
  ];
  const CreditCardCampos = [
    {
      label: 'Nome do cartão de crédito',
      key: 'holder',
    },
    {
      label: 'Número do Cartão de Crédito',
      key: 'cardNumber',
    },
    {
      label: 'Código de Segurança',
      key: 'securityCode',
    },
  ];
  const endereco = [
    {
      label: 'Logradouro',
      key: 'nomeLogradouro',
    },
    {
      label: 'Bairro',
      key: 'bairro',
    },
    {
      label: 'Cep',
      key: 'cep',
      mask: 'cep',
    },
    {
      label: 'Número',
      key: 'numero',
    },
  ];
  return (
    <>
      <Title>Confirme os dados:</Title>
      <Subtitle>Dados pessoais:</Subtitle>
      {campos.map((campo) => (
        <Row key={campo.key}>
          <TextField
            label={campo.label}
            value={dadosCadastrais?.[campo.key]}
            mask={campo.mask}
            disabled
          />
        </Row>
      ))}
      {/*<Subtitle>Endereço do paciente:</Subtitle>
      {endereco.map((campo) => (
        <Row key={campo.key}>
          <TextField
            label={campo.label}
            value={dadosCadastrais?.endereco?.[campo.key]}
            mask={campo.mask}
            disabled
          />
        </Row>
      ))}
      <Row>
        <TextField
          label={'estado'}
          value={dadosCadastrais?.endereco?.estado?.nome}
          disabled
        />
      </Row>
      <Row>
        <TextField
          label={'cidade'}
          value={dadosCadastrais?.endereco?.municipio?.nome}
          disabled
        />
      </Row>*/}
      {!dadosCadastrais?.id && whitelabel === "DR_ATENDE" && (
        <>
          <Subtitle>Plano:</Subtitle>
          <PlanoCard {...dadosCadastrais.plano}></PlanoCard>
          {/*<Subtitle>Dados do cartão:</Subtitle>
      {CreditCardCampos.map((campo) => (
        <Row key={campo.key}>
          <TextField
            label={campo.label}
            value={dadosCadastrais?.[campo.key]}
            mask={campo.mask}
            disabled
          />
        </Row>
      ))}
      <InputDateForm
        variant="outlined"
        openTo="month"
        views={["year", "month"]}
        value={dadosCadastrais?.expirationDate ? dadosCadastrais?.expirationDate : ""}
        format="MM/YYYY"
        placeholder={"__/____"}
        mask={value => (value ? [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/] : [])}
        disabled
        fullWidth
      />
      <Subtitle>Endereço de cobrança:</Subtitle>
      {endereco.map((campo) => (
        <Row key={campo.key}>
          <TextField
            label={campo.label}
            value={dadosCadastrais?.enderecoCobranca?.[campo.key]}
            mask={campo.mask}
            disabled
          />
        </Row>
      ))}
      <Row >
        <TextField
          label={"estado"}
          value={dadosCadastrais?.enderecoCobranca?.estado?.nome}
          disabled
        />
      </Row>
      <Row >
        <TextField
          label={"cidade"}
          value={dadosCadastrais?.enderecoCobranca?.municipio?.nome}
          disabled
        />
      </Row>*/}
        </>
      )}
    </>
  );
};

const Row = styled.div`
  display: flex;
  gap: 5px;
`;
const Title = styled.h1`
  font-family: 'Poppins';
  font-weight: 700;
  font-size: 14px;
`;
const Subtitle = styled.h1`
  font-family: 'Poppins';
  font-weight: 700;
  font-size: 12px;
`;
